import React from "react"
import { Tooltip } from "@mui/material"

type Props = {
  tooltipText: string
  children: React.ReactElement
}

const TooltipComponent = ({ tooltipText, children }: Props) => {
  return (
    <Tooltip title={tooltipText} placement="top">
      {children}
    </Tooltip>
  )
}

export default TooltipComponent
